<template>
  <div>
    <v-dialog
      v-model="show"
      scrollable
      :persistent="$store.getters.getPackage === 'premium'"
      max-width="1000px"
    >
      <v-card>
        <v-card-text
          style="max-height: 800px;"
          :style="$store.getters.getPackage === 'premium' ? 'min-height:100px' : 'min-height:300px'"
        >
          <!-- <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup> -->
          <div v-if="loading" class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <template v-else>
            <v-radio-group v-model="filterType" row @change="onChangeFilterType">
              <v-radio :label="$t('Replying all post(s)')" color="primary" value="all"></v-radio>
              <template v-if="$store.getters.getPackage === 'premium'">
                <v-radio
                  :label="$t('Replying selected post(s)')"
                  color="primary"
                  value="includes"
                ></v-radio>
                <v-radio
                  :label="$t('Not replying selected post(s)')"
                  color="primary"
                  value="excludes"
                ></v-radio>
                <v-radio
                  :label="$t('Replying post(s) that has keywords')"
                  color="primary"
                  value="post_keywords"
                ></v-radio>
              </template>
              <template v-else>
                <label class="mr-2" style="color:rgba(0,0,0,.54)">
                  <v-premium-lock :inline="true"></v-premium-lock>
                  {{ $t('Replying selected post(s)') }}
                </label>
                <label class="mr-2" style="color:rgba(0,0,0,.54)">
                  <v-premium-lock :inline="true"></v-premium-lock>
                  {{ $t('Not replying selected post(s)') }}
                </label>
                <label class="mr-2" style="color:rgba(0,0,0,.54)">
                  <v-premium-lock :inline="true"></v-premium-lock>
                  {{ $t('Replying post(s) that has keywords') }}
                </label>
              </template>
            </v-radio-group>
            <template v-if="filterType == 'all'">
              <div class="text-xs-center caption py-2">
                {{ $t('All posts are replied.') }}
              </div>
            </template>
            <template v-else-if="filterType == 'includes'">
              <v-layout>
                <v-flex class="pt-2 pb-2">
                  {{ $t('Replying selected post(s)') }}
                  <a
                    href="https://tinyurl.com/3t2h9krf"
                    target="blank"
                    ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
                  ></a>
                </v-flex>
              </v-layout>

              <div style="max-height: 300px; overflow-y: auto">
                <div class="text-xs-center caption py-2" v-if="includes.length == 0">
                  {{ $t('All posts are replied.') }}
                  {{ $t('Click the button Add Post for more.') }}
                </div>
                <template v-else v-for="(post, index) in includes">
                  <div class="z-border-red mb-2 pa-2" :key="index">
                    <v-layout>
                      <v-flex class=" pa-2">
                        <a
                          :href="
                            post.type == 'fb' ? 'https://www.facebook.com/' + post.id : post.link
                          "
                          target="_blank"
                          class="primary--text"
                          ><i
                            :class="{
                              'fab fa-facebook': !post.type || post.type == 'fb',
                              'fab fa-instagram': post.type && post.type == 'instagram'
                            }"
                            class="mr-2"
                          />{{ post.name || post.description }}</a
                        >
                        <div class="caption grey--text">
                          {{ post.id }}
                        </div>
                      </v-flex>
                      <v-flex class="text-xs-right pa-2">
                        <v-btn
                          small
                          fab
                          outline
                          class="ma-0 extra-small"
                          color="primary"
                          @click="onDeleteIncludePost(post)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
              </div>

              <div class="text-xs-center">
                <v-btn
                  outline
                  color="primary"
                  small
                  @click="
                    isShow = true
                    filterType = 'includes'
                  "
                >
                  <v-icon small>add</v-icon>
                  {{ $t('Add ads post') }}
                </v-btn>
                <v-btn depressed color="primary" small @click="showPost = true">
                  <v-icon small>add</v-icon>
                  {{ $t('Add post') }}
                </v-btn>
              </div>
            </template>

            <template v-else-if="useexclude && filterType == 'excludes'">
              <v-layout>
                <v-flex class="pt-2 pb-2">
                  {{ $t('Not replying selected post(s)') }}
                </v-flex>
              </v-layout>

              <div style="max-height: 300px; overflow-y: auto">
                <div class="text-xs-center caption py-2" v-if="excludes.length == 0">
                  {{ $t('All posts are replied.') }}
                  {{ $t('Click the button Add Post for more.') }}
                </div>

                <template v-else v-for="(post, index) in excludes">
                  <div class="z-border-red mb-2 pa-2" :key="index">
                    <v-layout>
                      <v-flex class=" pa-2">
                        <a
                          :href="
                            post.type == 'fb' ? 'https://www.facebook.com/' + post.id : post.link
                          "
                          target="_blank"
                          class="primary--text"
                          ><i
                            :class="{
                              'fab fa-facebook': !post.type || post.type == 'fb',
                              'fab fa-instagram': post.type && post.type == 'instagram'
                            }"
                            class="mr-2"
                          />{{ post.name || post.description }}</a
                        >
                        <div class="caption grey--text">
                          {{ post.id }}
                          <template v-if="post.type == 'instagram'">
                            <v-premium-lock2
                              :value="!check_privilege('instagram')"
                              type="premium"
                              class="mt-2"
                            />
                          </template>
                        </div>
                      </v-flex>
                      <v-flex class="text-xs-right pa-2">
                        <v-btn
                          small
                          fab
                          outline
                          class="ma-0 extra-small"
                          color="primary"
                          @click="onDeleteExcludePost(post)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>

                <div class="text-xs-center">
                  <v-btn
                    outline
                    color="primary"
                    small
                    @click="
                      isShow = true
                      filterType = 'excludes'
                    "
                  >
                    <v-icon small>add</v-icon>
                    {{ $t('Add ads post') }}
                  </v-btn>
                  <v-btn depressed color="primary" small @click="showPost = true">
                    <v-icon small>add</v-icon>
                    {{ $t('Add post') }}
                  </v-btn>
                </div>
              </div>
            </template>

            <template v-else-if="filterType == 'post_keywords'">
              <v-layout>
                <v-flex class="pt-2 pb-2">
                  {{ $t('Replying post(s) that has keywords') }}
                  <a
                    href="https://tinyurl.com/v2zsjj2h"
                    target="blank"
                    ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
                  ></a>
                </v-flex>
              </v-layout>

              <div
                xs12
                class="form-control pa-1"
                :class="{ 'has-error': errorFilterTag.length > 0 }"
              >
                <tags
                  v-model="keyword"
                  :tags="keywords"
                  @tags-changed="addKeywords"
                  @before-adding-tag="checkKeyword"
                  style="margin-bottom: 10px"
                  :btnText="$t('Add keyword')"
                  :isDrag="false"
                ></tags>

                <span class="text-error" v-if="errorFilterTag.length > 0">
                  <template v-if="errorFilterTag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorFilterTag.includes('duplicate')">{{
                    $t('Duplicate Tag')
                  }}</template>
                </span>
              </div>

              <div class="red--text">
                {{ $t('Remark') }} : {{ $t('Replying post(s) that has keywords. They are') }}
              </div>
            </template>

            <v-dialog persistent v-model="isShow" max-width="600">
              <v-card>
                <v-card-text>
                  <div class="form-control">
                    <input type="text" v-model="adsName" placeholder="Post Name" />
                  </div>

                  <div class="form-control">
                    <input type="text" v-model="adsValue" placeholder="PAGE ID_POST ID" />
                  </div>

                  <div class="text-xs-center">
                    <v-btn depressed color="primary" @click="onAddAdsPost">{{ $t('Add') }}</v-btn>
                    <v-btn
                      outline
                      color="grey"
                      @click="
                        isShow = false
                        adsValue = null
                        adsName = null
                      "
                      >{{ $t('cancel') }}</v-btn
                    >
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <!-- <div
          class="text-xs-center caption grey--text mt-2"
          v-if="selectedBot.instagram_business_account"
        >
          {{ $t('Not support Instagram Live') }}
        </div> -->
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline @click="cancelPost">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="saveEditPost">
            {{ $t('Select') }}
          </v-btn>

          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPost" scrollable max-width="600px">
      <v-card>
        <div class="form-control px-2 pt-2 pb-1">
          <input type="text" v-model="search" :placeholder="$t('Search')" />
        </div>
        <v-divider></v-divider>
        <v-tabs
          v-model="channel"
          v-if="selectedBot.instagram_business_account"
          dark
          centered
          icons-and-text
          :color="$vuetify.theme.primary"
          :slider-color="'white'"
          show-arrows
        >
          <v-tab ripple :key="'fb'" :href="'#fb'" :style="`color:${$vuetify.theme.primary}`"
            >{{ $t('Facebook') }}
            <i class="fab fa-facebook" />
          </v-tab>
          <v-tab
            ripple
            :key="'instagram'"
            :href="'#instagram'"
            :style="`color:${$vuetify.theme.primary}`"
            >{{ $t('Instagram') }}
            <i class="fab fa-instagram" />
          </v-tab>
        </v-tabs>
        <v-card-text max-height="600px">
          <template v-if="channel == 'fb'">
            <v-tabs v-model="tab" color="white" :slider-color="$vuetify.theme.primary" show-arrows>
              <v-tab ripple :key="'published_post'" :href="'#published_post'">{{
                $t('Published post')
              }}</v-tab>

              <v-tab ripple :key="'schedule_post'" :href="'#schedule_post'">{{
                $t('Schedule post')
              }}</v-tab>

              <v-tab ripple :key="'fb_reels_post'" :href="'#fb_reels_post'">{{
                $t('Reels post')
              }}</v-tab>

              <v-tabs-items touchless>
                <v-tab-item :key="'published_post'" touchless :value="'published_post'">
                  <div style="padding: 15px 25px">
                    <div v-if="loading" class="spinner text-xs-center">
                      <img
                        class="z-loop"
                        src="/static/img/assets/loading/z-loop.png"
                        alt="loading"
                      />
                    </div>
                    <template v-else-if="filterPublishedPost.length > 0">
                      <div
                        class="z-border-red mb-1"
                        style="padding: 10px;  position: relative;cursor: pointer"
                        v-for="(p, index) in filterPublishedPost"
                        :key="'published_post_' + index"
                      >
                        <v-layout>
                          <v-flex>
                            <div style="padding-left: 10px;word-break: break-all;">
                              <a
                                :href="'https://www.facebook.com/' + p.id"
                                target="_blank"
                                rel="noopener noreferrer"
                                :title="p.name"
                                >{{ p.name | truncate(200) }}</a
                              >
                            </div>
                          </v-flex>

                          <v-flex shrink>
                            <v-btn small depressed @click="selectedPost(p)">
                              {{ $t('Select') }}
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>

                      <div class="text-xs-center">
                        <v-btn
                          color="primary"
                          outline
                          v-if="hasMorePublishPost"
                          @click="getPublishedPost"
                          :loading="loadingPublishedPost"
                          >{{ $t('more') }}</v-btn
                        >
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-xs-center">{{ $t('No post') }}</div>
                    </template>
                  </div>
                </v-tab-item>
                <v-tab-item :key="'schedule_post'" touchless :value="'schedule_post'">
                  <div style="padding: 15px 25px">
                    <div v-if="loading" class="spinner text-xs-center">
                      <img
                        class="z-loop"
                        src="/static/img/assets/loading/z-loop.png"
                        alt="loading"
                      />
                    </div>
                    <template v-else-if="filterSchedulePost.length > 0">
                      <div
                        class="z-border-red"
                        style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
                        v-for="(p, index) in filterSchedulePost"
                        :key="'schedule_post_' + index"
                      >
                        <v-layout>
                          <v-flex>
                            <div style="padding-left: 10px;word-break: break-all;">
                              <a
                                :href="'https://www.facebook.com/' + p.id"
                                target="_blank"
                                rel="noopener noreferrer"
                                :title="p.name"
                                >{{ p.name | truncate(200) }}</a
                              >
                            </div>
                          </v-flex>

                          <v-flex shrink>
                            <v-btn small depressed @click="selectedPost(p)">
                              {{ $t('Select') }}
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>

                      <div class="text-xs-center">
                        <v-btn
                          color="primary"
                          outline
                          v-if="hasMoreSchedulePost"
                          @click="getSchedulePost"
                          :loading="loadingSchedulePost"
                          >{{ $t('more') }}</v-btn
                        >
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-xs-center">{{ $t('No post') }}</div>
                    </template>
                  </div>
                </v-tab-item>
                <v-tab-item :key="'fb_reels_post'" touchless :value="'fb_reels_post'">
                  <div style="padding: 15px 25px">
                    <div v-if="loading" class="spinner text-xs-center">
                      <img
                        class="z-loop"
                        src="/static/img/assets/loading/z-loop.png"
                        alt="loading"
                      />
                    </div>
                    <template v-else-if="filterFbReelsPost.length > 0">
                      <div
                        class="z-border-red mb-1"
                        style="padding: 10px;  position: relative;cursor: pointer"
                        v-for="(p, index) in filterFbReelsPost"
                        :key="'published_post_' + index"
                      >
                        <v-layout>
                          <v-flex>
                            <div style="padding-left: 10px;word-break: break-all;">
                              <a
                                :href="'https://www.facebook.com/' + p.id"
                                target="_blank"
                                rel="noopener noreferrer"
                                :title="p.description ? p.description : ''"
                                >{{ p.description ? p.description : '' | truncate(200) }}</a
                              >
                            </div>
                            <div class="caption grey--text">
                              {{ p.id }}
                            </div>
                          </v-flex>

                          <v-flex shrink>
                            <v-btn small depressed @click="selectedPost(p)">
                              {{ $t('Select') }}
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>

                      <div class="text-xs-center">
                        <v-btn
                          color="primary"
                          outline
                          v-if="hasMoreFbReelsPost"
                          @click="getFbReelsPost"
                          :loading="loadingFbReelsPost"
                          >{{ $t('more') }}</v-btn
                        >
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-xs-center">{{ $t('No post') }}</div>
                    </template>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </template>
          <template v-else-if="channel == 'instagram'">
            <div style="padding: 15px 25px">
              <div v-if="loading" class="spinner text-xs-center">
                <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
              </div>
              <template v-else-if="filterIGPost.length > 0">
                <div
                  class="z-border-red mb-1"
                  style="padding: 10px;  position: relative;cursor: pointer"
                  v-for="(p, index) in filterIGPost"
                  :key="'published_post_' + index"
                >
                  <v-layout>
                    <v-flex>
                      <div style="padding-left: 10px;word-break: break-all;">
                        <a :href="p.link" target="_blank" rel="noopener noreferrer" :title="p.name">
                          <v-avatar size="50" class="mr-2" tile
                            ><img
                              :src="
                                p.media_type === 'VIDEO'
                                  ? '/static/img/assets/_global/reels.png'
                                  : p.media_url
                              "/></v-avatar
                          >{{ p.name | truncate(200) }}</a
                        >
                      </div>
                    </v-flex>

                    <v-flex shrink>
                      <v-btn
                        v-if="check_privilege('instagram')"
                        small
                        depressed
                        @click="selectedPost(p)"
                      >
                        {{ $t('Select') }}
                      </v-btn>
                      <v-premium-lock2
                        :value="!check_privilege('instagram')"
                        type="premium"
                        class="mt-2"
                      />
                    </v-flex>
                  </v-layout>
                </div>

                <div class="text-xs-center">
                  <v-btn
                    color="primary"
                    outline
                    v-if="hasMoreIGPost"
                    @click="getIGPost"
                    :loading="loadingIGPost"
                    >{{ $t('more') }}</v-btn
                  >
                </div>
              </template>
              <template v-else>
                <div class="text-xs-center">{{ $t('No post') }}</div>
              </template>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import api from '@/api'
import { Promise } from 'q'
import Tags from '@/components/elements/Tags'
export default {
  props: {
    includePost: {
      default: []
    },
    excludePost: {
      default: []
    },
    post_keywords: {
      default: []
    },
    show: {
      default: false
    },
    singleselect: {
      default: false
    },
    useexclude: {
      default: false
    }
  },
  components: {
    ModalDialog,
    Tags
  },
  data: function() {
    return {
      showPost: false,
      publishedPostOption: [],
      schedulePostOption: [],
      posts: '',
      search: '',
      tab: 'published_post',
      loading: false,
      nextPublishPost: null,
      hasMorePublishPost: true,
      nextSchedulePost: null,
      hasMoreSchedulePost: true,
      loadingPublishedPost: true,
      loadingSchedulePost: true,
      isShow: false,
      adsValue: '',
      adsName: '',
      includes: [],
      excludes: [],
      keywords: [],
      filterType: 'all',
      keyword: '',
      errorFilterTag: [],
      channel: 'fb',
      hasMoreFbReelsPost: true,
      hasMoreIGPost: true,
      loadingIGPost: true,
      loadingFbReelsPost: true,
      igPostOption: [],
      reelsPostOption: [],
      nextIGPost: null,
      nextFbReelsPost: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    filterIGPost() {
      var vm = this

      var includes = this.includes.map(el => {
        return el.id
      })
      var excludes = this.excludes.map(el => {
        return el.id
      })
      var posts = this.igPostOption.filter(el => {
        return !includes.includes(el.id) && !excludes.includes(el.id)
      })
      if (vm.search !== '') {
        return posts.filter(function(post) {
          return post.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return posts
    },
    filterFbReelsPost() {
      var vm = this

      var includes = this.includes.map(el => {
        return el.id
      })
      var excludes = this.excludes.map(el => {
        return el.id
      })
      var posts = this.reelsPostOption.filter(el => {
        return !includes.includes(el.id) && !excludes.includes(el.id)
      })
      if (vm.search !== '') {
        return posts.filter(function(post) {
          let search = post.name || post.description ? post.description : ''
          return search.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return posts
    },
    filterPublishedPost: function() {
      var vm = this

      var includes = this.includes.map(el => {
        return el.id
      })
      var excludes = this.excludes.map(el => {
        return el.id
      })
      var posts = this.publishedPostOption.filter(el => {
        return !includes.includes(el.id) && !excludes.includes(el.id)
      })
      if (vm.search !== '') {
        return posts.filter(function(post) {
          return post.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return posts
    },
    filterSchedulePost: function() {
      var vm = this

      var includes = this.includes.map(el => {
        return el.id
      })
      var excludes = this.excludes.map(el => {
        return el.id
      })
      var posts = this.schedulePostOption.filter(el => {
        return !includes.includes(el.id) && !excludes.includes(el.id)
      })
      if (vm.search !== '') {
        return posts.filter(function(post) {
          return post.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return posts
    }
  },
  async mounted() {
    var vm = this
    vm.posts = vm.includePost
    var posts = []
    if (this.posts && this.posts != '' && this.posts != null) {
      try {
        posts = JSON.parse(this.posts)
      } catch (error) {
        var tmp_posts = this.posts.split(',')
        posts = tmp_posts.map(el => {
          return {
            id: el,
            name: el
          }
        })
      }
    }
    vm.includes = posts
    if (posts.length > 0) {
      this.filterType = 'includes'
    } else {
      try {
        vm.excludes = JSON.parse(this.excludePost)
      } catch (error) {
        vm.excludes = []
      }
      if (vm.excludes.length > 0) {
        this.filterType = 'excludes'
      } else {
        try {
          let keywords = JSON.parse(this.post_keywords)
          vm.keywords = keywords.map(function(tag, index) {
            return { text: tag }
          })
        } catch (error) {
          vm.keywords = []
        }
        if (vm.keywords.length > 0) {
          this.filterType = 'post_keywords'
        } else {
          this.filterType = 'all'
        }
      }
    }
    vm.cache_includes = JSON.stringify(vm.includes)
    vm.cache_excludes = JSON.stringify(vm.excludes)
    vm.loading = true
    try {
      await vm.getPublishedPost()
      await vm.getSchedulePost()
      await vm.getFbReelPost()
      if (vm.selectedBot.instagram_business_account) {
        await vm.getIGPost()
      }
    } catch (error) {}
    vm.loading = false
  },
  methods: {
    addKeywords: function(newKeyword) {
      this.keywords = newKeyword
    },
    checkKeyword(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    async onChangeFilterType(val) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to change the reply mode?'),
        text: this.$t('The change may delete your selected posts.'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        this.filterType = val
        if (val == 'includes') {
          this.excludes = []
          this.keywords = []
        } else if (val == 'excludes') {
          this.includes = []
          this.keywords = []
        } else if (val == 'post_keywords') {
          this.excludes = []
          this.includes = []
        }
      } else {
        if (this.includes.length > 0) {
          this.filterType = 'includes'
        } else if (this.excludes.length > 0) {
          this.filterType = 'excludes'
        } else if (this.keywords.length > 0) {
          this.filterType = 'post_keywords'
        } else {
          this.filterType = 'all'
        }
        // this.filterType = val == 'includes' ? 'excludes' : 'includes'
      }
    },
    clearAllPost: async function() {
      var result = await this.$swal.fire({
        title: this.$t('ต้องการเลือกทุกโพสต์'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        this.includes = []
        this.excludes = []
        this.keywords = []
        this.saveEditPost()
      }
    },
    getPublishedPost: function() {
      return new Promise((resolve, reject) => {
        var vm = this
        vm.loadingPublishedPost = true

        api.getPublishedPost(vm.nextPublishPost).then(
          function(response) {
            if (response.paging && response.paging.next) {
              vm.nextPublishPost = response.paging.next
            } else {
              vm.hasMorePublishPost = false
            }
            if (response.data) {
              vm.publishedPostOption = response.data.map(function(post, index) {
                if (post.message || post.story) {
                  return {
                    id: post.id,
                    name: post.message ? post.message : post.story,
                    selected: vm.posts ? vm.posts.includes(post.id) : false,
                    type: 'fb'
                  }
                } else {
                  return {
                    id: post.id,
                    name: post.id,
                    selected: vm.posts ? vm.posts.includes(post.id) : false,
                    type: 'fb'
                  }
                }
              })
              vm.loadingPublishedPost = false
              resolve()
            }
          },
          function(e) {
            vm.loadingPublishedPost = false
            reject(e)
          }
        )
      })
    },
    getSchedulePost: function() {
      return new Promise((resolve, reject) => {
        var vm = this

        vm.loadingSchedulePost = true
        api.getSchedulePost(vm.nextSchedulePost).then(
          function(response) {
            if (response.paging && response.paging.next) {
              vm.nextSchedulePost = response.paging.next
            } else {
              vm.hasMoreSchedulePost = false
            }
            if (response.data) {
              response.data.map(function(post, index) {
                if (post.message || post.story) {
                  vm.schedulePostOption.push({
                    id: post.id,
                    name: post.message ? post.message : post.story,
                    selected: vm.posts ? vm.posts.includes(post.id) : false,
                    type: 'fb'
                  })
                } else {
                  vm.schedulePostOption.push({
                    id: post.id,
                    name: post.id,
                    selected: vm.posts ? vm.posts.includes(post.id) : false,
                    type: 'fb'
                  })
                }
              })
              vm.loadingSchedulePost = false
              resolve()
            }
          },
          function(e) {
            vm.loadingSchedulePost = false
            reject(e)
          }
        )
      })
    },
    getFbReelPost() {
      return new Promise((resolve, reject) => {
        var vm = this

        vm.loadingFbReelsPost = true
        api.getFbReelsPost(vm.nextFbReelsPost, vm.selectedBot.pageid).then(
          function(response) {
            if (response.paging && response.paging.next) {
              vm.nextFbReelsPost = response.paging.next
            } else {
              vm.hasMoreFbReelsPost = false
            }
            if (response.data) {
              vm.reelsPostOption = response.data
                .map(function(post, index) {
                  return {
                    id: `${vm.selectedBot.pageid}_${post.post_id}`,
                    post_id: post.post_id,
                    description: post.description,
                    selected: vm.posts ? vm.posts.includes(post.id) : false,
                    type: 'fb'
                  }
                })
                .filter(el => el != null)
              vm.loadingFbReelsPost = false
              resolve()
            }
          },
          function(e) {
            vm.loadingFbReelsPost = false
            reject(e)
          }
        )
      })
    },
    getIGPost() {
      return new Promise((resolve, reject) => {
        var vm = this

        vm.loadingIGPost = true
        api.getIGPost(vm.nextIGPost).then(
          function(response) {
            if (response.paging && response.paging.next) {
              vm.nextIGPost = response.paging.next
            } else {
              vm.hasMoreIGPost = false
            }
            if (response.data) {
              vm.igPostOption = response.data
                .map(function(post, index) {
                  if (post.is_comment_enabled) {
                    return {
                      id: post.id,
                      name: post.captions ? post.captions : post.id,
                      media_type: post.media_type,
                      media_url: post.media_url,
                      link: post.permalink,
                      selected: vm.posts ? vm.posts.includes(post.id) : false,
                      type: 'instagram'
                    }
                  } else return null
                })
                .filter(el => el != null)
              vm.loadingIGPost = false
              resolve()
            }
          },
          function(e) {
            vm.loadingIGPost = false
            reject(e)
          }
        )
      })
    },
    onDeletePost: function(id) {
      var vm = this
      var index = vm.selectedPosts.findIndex(function(el) {
        return el === id
      })

      if (index != -1) {
        vm.selectedPosts.splice(index, 1)
      }
      vm.$forceUpdate()
    },
    onDeleteIncludePost(post) {
      var vm = this
      var index = vm.includes.findIndex(function(el) {
        return el.id === post.id
      })

      if (index != -1) {
        vm.includes.splice(index, 1)
      }
    },
    onDeleteExcludePost(post) {
      var vm = this
      var index = vm.excludes.findIndex(function(el) {
        return el.id === post.id
      })

      if (index != -1) {
        vm.excludes.splice(index, 1)
      }
    },
    onAddAdsPost: function() {
      if (!this.adsValue && this.adsValue.trim() == '') {
        return false
      }
      var post = {
        id: this.adsValue,
        name: this.adsName && this.adsName.trim() != '' ? this.adsName.trim() : this.adsValue
      }
      if (this.filterType == 'includes') {
        this.includes.push(post)
      } else {
        this.excludes.push(post)
      }
      this.isShow = false
    },
    selectedPublishedPost: function(id) {
      var vm = this
      vm.publishedPostOption.map(function(post, index) {
        if (post.id === id) {
          vm.publishedPostOption[index].selected = !vm.publishedPostOption[index].selected
          return false
        } else if (vm.singleselect) {
          vm.publishedPostOption[index].selected = false
        }
      })

      var index = vm.selectedPosts.findIndex(function(el) {
        return el === id
      })
      if (index == -1) {
        if (vm.singleselect) {
          vm.selectedPosts = id
        } else {
          vm.selectedPosts.push(id)
        }
      } else {
        vm.selectedPosts.splice(index, 1)
      }
    },
    selectedPost: function(post) {
      var vm = this
      var post = {
        id: post.id,
        name: post.name,
        type: post.type,
        link: post.link,
        description: post.description
      }
      if (this.filterType == 'includes') {
        if (this.singleselect) {
          vm.includes = [post]
        } else {
          vm.includes.push(post)
        }
      } else {
        if (this.singleselect) {
          vm.excludes = [post]
        } else {
          vm.excludes.push(post)
        }
      }
      this.showPost = false
    },
    selectedExcludePost: function(post) {
      var vm = this
      var post = {
        id: post.id,
        name: post.name,
        description: post.description
      }
      if (this.singleselect) {
        vm.excludes = [post]
      } else {
        vm.excludes.push(post)
      }
    },
    saveEditPost: function() {
      var vm = this
      if (this.filterType == 'all') {
        this.includes = []
        this.excludes = []
        this.keywords = []
      }

      let keywords = []

      if (this.filterType == 'post_keywords') {
        keywords = this.keywords.map(el => {
          return el.text
        })
      }

      vm.$emit('save', {
        includes: JSON.stringify(this.includes),
        excludes: JSON.stringify(this.excludes),
        post_keywords: JSON.stringify(keywords)
      })

      vm.cache_includes = JSON.stringify(vm.includes)
      vm.cache_excludes = JSON.stringify(vm.excludes)
      vm.cache_post_keywords = JSON.stringify(keywords)
      vm.$emit('close')
    },
    cancelPost: function() {
      var vm = this
      vm.includes = JSON.parse(vm.cache_includes)
      vm.excludes = JSON.parse(vm.cache_excludes)

      try {
        let keywords = JSON.parse(vm.cache_post_keywords)
        vm.keywords = keywords.map(function(tag, index) {
          return { text: tag }
        })
      } catch (error) {}
      vm.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentSelectPost.vue